import "./styles.scss";

const AppBase = ({ children }: React.PropsWithChildren<{}>) => {
    return <div className="one-base">
        {children}
    </div>
}

export default AppBase